/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Grid, TextField } from '@material-ui/core';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';

import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  TO_DATE_GREATER_THAN_FROM,
  FROM_DATE_REQUIRED,
  REBATE_SELECT,
  TO_DATE_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  setSearchInput,
  getInstitutionalClaimsDiscrepancyResultGrid,
  setInstitutionalClaimsData,
} from '../Store/actions';
import {
  autoFormateDate,
  tabHighLigther,
  validateDate,
} from '../../../../SharedModules/utilities/utilities';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

export default function ReqInstitutionalClaim(props) {
  const dispatch = useDispatch();
  const {
    planType: planTypeList,
    errors,
    isLoading,
    // selectedPlanType,
    // rebateProgramValue,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    // fromDateValue,
    // toDateValue,
    claimAuditReducer,
    allAdjustmentGrid,
    // claimAuditSelected: claimAuditSelectedValue,
    searchResult,
    searchScreenVar: {
      rebateProgramValue,
      selectedPlanType,
      fromDateValue,
      toDateValue,
      claimAuditSelected: claimAuditSelectedValue,
    },
  } = useSelector((state) => state?.sharedState?.InstitutionalClaimsReducer);
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [radioList, setRadioList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [selectList, setSelectList] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );

  const [errorList, setErrorList] = React.useState(errors);
  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [toDate, setToDate] = React.useState(toDateValue);
  const [claimAuditSelected, setClaimAuditSelected] = React.useState(
    claimAuditSelectedValue
  );
  const [claimCategorySelected, setClaimCategorySelected] = React.useState(
    'IR - Institutional Revenue Code'
  );
  const [isSearchClicked, setSearchClicked] = React.useState(false);

  // Clear the toast error
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [rebateProgram, radioList, fromDate, toDate, claimAuditSelected]);

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  }; // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // function to validate from Date and toDate on onblur
  const handleOnBlur = (type, input) => {
    const value = autoFormateDate(input);
    let allErrors = [];
    let fromError = [];
    let toError = [];
    if (!fromDate || (type === 'fromDate' && !value))
      fromError = [{ field: 'fromDate', message: FROM_DATE_REQUIRED }];
    if (type === 'fromDate' && value) {
      setFromDate(value.toUpperCase());
      fromError = validateDate(value, 'fromDate');
      if (!toDate && !fromError.length) {
        setToDate(value.toUpperCase());
      }
    }
    if (type === 'toDate') {
      setToDate(value.toUpperCase());
      if (!value) toError = [{ field: 'toDate', message: TO_DATE_REQUIRED }];
      if (value != '') {
        toError = validateDate(value, 'toDate');
      }
    }

    if (fromError.length === 0 && toError.length === 0) {
      let frmDt, toDt;
      if (type === 'fromDate' && value) frmDt = value;
      else frmDt = fromDate;
      if (type === 'toDate' && value) toDt = value;
      else toDt = toDate;
      if (new Date(frmDt) > new Date(toDt)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      }
    }
    allErrors = [...allErrors, ...fromError, ...toError];
    setErrorList(allErrors);
  };

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen
  const handleSearchClick = () => {
    let allErrors = [];
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    if (claimCategorySelected === '-1') {
      allErrors.push({
        field: 'claimCategory',
        message: 'Claim Category is Required.',
      });
    }
    const fromError = validateDate(fromDate, 'fromDate');
    // let toError = validateDate(toDate, 'toDate');
    if (fromError.length === 0) {
      if (new Date(fromDate) > new Date(toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      }
    }
    allErrors = [...allErrors, ...fromError];

    setErrorList(allErrors);
    if (allErrors.length === 0) {
      dispatch(setInstitutionalClaimsData([]));
      setSearchClicked(true);
      // Variable to get fullname of rebate program from rebate program list(selectList)
      let rebateProgramName =
        selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
      rebateProgramName = `${rebateProgramName?.rebateProgramCd} - ${
        rebateProgramName?.shortDescr || ''
      }`;
      dispatch(
        setSearchInput({
          fromDateValue: fromDate,
          toDateValue: toDate,
          selectedPlanType: planType,
          rebateProgramValue: rebateProgram,
          rebateProgramName,
          claimAuditSelected,
          claimCategorySelected,
          searchScreenVar: {
            rebateProgramName,
            selectedPlanType: planType,
            rebateProgramValue: rebateProgram,
            fromDateValue: fromDate,
            toDateValue: toDate,
            claimAuditSelected,
            claimCategorySelected,
          },
        })
      );
      dispatch(
        getInstitutionalClaimsDiscrepancyResultGrid({
          rpc: rebateProgram,
          startDt: fromDate,
          endDt: toDate === '' ? fromDate : toDate,
          claimCategory: 'IR',
          clearedInd: claimAuditSelected,
        })
      );
    }
  };

  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));

    updateTabs.push({
      navTo: '/dispInstitionalClaimsTypeDiscrepancy',

      value: 'Display Institutional Claims Type Discrepancy',
    });

    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    props &&
      props.history &&
      props.history.push({
        pathname: '/dispInstitionalClaimsTypeDiscrepancy',
      });
    dispatch(
      clearReduxForFilterAndSort('/dispInstitionalClaimsTypeDiscrepancy')
    );
  }

  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Institutional Claims Unit Type Discrepancy"
      />
      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
      <div className="tab-body">
        <div className="row mb-3">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              data-testid="Institutional_Claims_Plan_Type"
              id="filter-plan-by-radio-btn-action"
              labelName="Plan Type"
              required
              optionList={radioList || []}
              defaultValue={planType}
              filterAction={(value) => {
                setPlanType(value);
                setRebateProgram('-1');
                const errors = errorList.filter(
                  (error) => error.field !== 'rebateProgram'
                );
                setErrorList([...errors]);
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-4">
            <>
              <Fieldset label="Rebate Program" required>
                <div style={{ marginTop: 18 }}>
                  <SelectBoxComponent
                    data-testid="Institutional_claims_Rebate_Program"
                    id="filter-plan-by-radio-btn-action"
                    labelName="Rebate Program"
                    required
                    select
                    selectOne
                    optionList={selectList || []}
                    defaultValue={rebateProgram}
                    filterAction={(value) => {
                      setRebateProgram(value);
                      setRebateProgramName(value);
                      const errors = errorList.filter(
                        (error) => error.field !== 'rebateProgram'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.find((error) => error.field === 'rebateProgram')
                        ?.message
                    }
                  />
                </div>
              </Fieldset>
            </>
          </div>
          <div className="col-4">
            <>
              <Fieldset label="Claim Category" required>
                <div style={{ marginTop: 18 }}>
                  <SelectBoxComponent
                    data-testid="Institutional_claims_category"
                    id="filter-plan-by-radio-btn-action"
                    labelName="Claim Category"
                    required
                    select
                    selectOne
                    optionList={[
                      {
                        name: 'IR - Institutional Revenue Code',
                        id: 'IR - Institutional Revenue Code',
                      },
                    ]}
                    defaultValue={claimCategorySelected}
                    filterAction={(name) => {
                      setClaimCategorySelected(name);
                      const errors = errorList.filter(
                        (error) => error.field !== 'claimCategory'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.find((error) => error.field === 'claimCategory')
                        ?.message
                    }
                  />
                </div>
              </Fieldset>
            </>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <Fieldset label="Date Range" required>
              <div className="form-wrapper p-0 mt-n3">
                <div className="mui-custom-form input-md field-xl mandate-fields">
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="From Date"
                        id="fromDate"
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        data-testid="Institutional_claims_From_date"
                        inputProps={{ maxLength: 10, id: 'fromDate' }}
                        name="From"
                        value={fromDate}
                        error={
                          errorList.filter(
                            (error) =>
                              error.field === 'fromDate' ||
                              error.field === 'fromDate>toDate'
                          )?.length > 0
                            ? 'mandate-fields'
                            : ''
                        }
                        className="mandate-fields"
                        onBlur={(e) => handleOnBlur('fromDate', e.target.value)}
                        onChange={(e) => {
                          const { value } = e.target;

                          setFromDate(value.toUpperCase());
                          setErrorList([
                            ...errorList.filter(
                              (error) =>
                                error.field !== 'fromDate' &&
                                error.field !== 'fromDate>toDate'
                            ),
                          ]);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="To Date"
                        id="toDate"
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        data-testid="Institutional_claims_To_date"
                        inputProps={{ maxLength: 10, id: 'toDate' }}
                        name="to"
                        value={toDate}
                        onBlur={(e) => handleOnBlur('toDate', e.target.value)}
                        onChange={(e) => {
                          setToDate(e.target.value.toUpperCase());
                          setErrorList([
                            ...errorList.filter(
                              (error) =>
                                error.field !== 'toDate' &&
                                error.field !== 'fromDate>toDate'
                            ),
                          ]);
                        }}
                        error={
                          errorList.filter(
                            (error) =>
                              error.field === 'toDate' ||
                              error.field === 'fromDate>toDate'
                          )?.length > 0
                            ? 'mandate-fields'
                            : ''
                        }
                        className="mandate-fields"
                      />
                    </Grid>
                    <Grid xs={12} md={12}>
                      <div
                        className="MuiFormHelperText-root Mui-error Mui-required"
                        style={{
                          padding: '0px 10px',
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                      >
                        {
                          errorList.find(
                            (error) =>
                              error.field === 'fromDate' ||
                              error.field === 'toDate' ||
                              error.field === 'fromDate>toDate'
                          )?.message
                        }
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Fieldset>
          </div>
          <div className="col-4 frr-three-col-radio">
            <RadioGroupComponent
              data-testid="Institutional_claims_cleared_Audit"
              id="filter-plan-by-radio-btn-action"
              labelName="Cleared Audit"
              required
              optionList={[
                { name: 'Yes', value: 'Yes' },
                { name: 'No', value: 'No' },
                { name: 'Both', value: 'Both' },
              ]}
              defaultValue={claimAuditSelected}
              filterAction={(value) => {
                setClaimAuditSelected(value);
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
        </div>
      </div>
      <div className="row" style={{ marginTop: 15 }}>
        <div className="btn-wrapper col-12">
          <Button
            data-testid="view_detail_ia"
            onClick={handleSearchClick}
            className="btn btn-success btn-search float-right"
          >
            <SVGComponent iconName="Icon-search" /> Search
          </Button>
        </div>
      </div>
    </div>
  );
}
